import type { FC } from "react";
import { useTranslation } from "react-i18next";
import {
  SummaryStep1,
  SummaryStep2,
  SummaryStep3,
  SummaryStep4,
} from "@/pages/Summary/SummarySteps";
import { SummaryCard } from "@/components/Cards";

export const SummaryCard2: FC = () => {
  const { t } = useTranslation();

  return (
    <SummaryCard title={t("summary.card2")} dataTest="summary-card2">
      <div className="space-y-4">
        <p className="text-base font-bold" data-test="summary-card2-description">
          {t("summary.card2Description")}
        </p>
        <SummaryStep1 />
        <SummaryStep2 />
        <SummaryStep3 />
        <SummaryStep4 />
      </div>
    </SummaryCard>
  );
};
